import React, { Component } from "react";
import axios from "axios";
import Alert from "react-s-alert";
import SimpleReactLightbox, { SRLWrapper } from "simple-react-lightbox";
import LeftSideNavigation from "../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../navigationSection/BottomNavigationMobile";
import Image from "react-bootstrap/Image";
import classnames from "classnames";
import Form from "react-bootstrap/Form";
import { TopTextReusableComponent } from "../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  InputBoxComponent,
  NewInputText,
  SelectBoxMUiInputComponent,
} from "../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import PositionRoleTitle from "../../../vendorOnboradingComponents/reusableOnboardingPopupComponent/PositionRoleTitle";
import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";
import {
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import InputNumberFunc from "../../../../function/InputNumberFunc";
import { InputCharacterCheck } from "../../../../function/InputCharNumCheckFunc";
import { RestaurantPointOfContact } from "../../../../store/validation/allValidationFile/onboardingProcessValidation/RestaurantPointOfContact";
import SingleImageReusableComponent from "../../../reusableComponents/imageUploadReusableComponent/SingleImageReusableComponent";
import { serverApi, imageUploadSize } from "../../../../config/Keys";
import { IconButton, FormHelperText } from "@material-ui/core";
import { DropDownBoxCrret } from "../../../reusableComponents/dropDownButtonReusable/DropDownButton";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../../store/actions/errorActions";
import { point_of_contact_error_check } from "../../../vendorOnboradingComponents/allScreens/pointOfContacts/errorChecker";
import { create_and_update_restaurant } from "../../../../store/actions/authAction";
import isEmpty from "../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../Loader/AmealioLoader";
import { AddButtonIconComponent } from "../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import { InputLabel, MenuItem, Select, FormControl } from "@material-ui/core";
import Media from "react-media";

const validEmailRegex = RegExp(
  /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i
);
// const validateForm = (errors) => {
//   let valid = true;
//   Object.values(errors).forEach((val) => val.length > 0 && (valid = false));
//   return valid;
// };

const options = {
  settings: {
    autoplaySpeed: 3000,
    disableKeyboardControls: false,
    disablePanzoom: false,
    disableWheelControls: false,
    hideControlsAfter: 3000,
    lightboxTransitionSpeed: 0.6,
    lightboxTransitionTimingFunction: "linear",
    overlayColor: "rgba(0, 0, 0, 0.9)",
    slideAnimationType: "fade",
    slideSpringValues: [300, 200],
    slideTransitionSpeed: 0.6,
    slideTransitionTimingFunction: "linear",
  },
  buttons: {
    showAutoplayButton: false,
    showCloseButton: true,
    showDownloadButton: false,
    showFullscreenButton: false,
    showNextButton: false,
    showPrevButton: false,
    showThumbnailsButton: false,
  },
  caption: {
    showCaption: false,
  },
  thumbnails: {
    showThumbnails: false,
  },
  progressBar: {
    showProgressBar: false,
  },
};

const revenueData = [
  { id: 1, name: "Accounting / Finance", value: "Accounting / Finance" },
  { id: 2, name: "Assistant Manager", value: "Assistant Manager" },
  { id: 3, name: "Back Office", value: "Back Office" },
  { id: 4, name: "Chef", value: "Chef" },
  { id: 5, name: "Delivery", value: "Delivery" },
  { id: 6, name: "Front Office", value: "Front Office" },
  { id: 7, name: "General Manager", value: "General Manager" },
  { id: 8, name: "Hostess. / Host", value: "Hostess. / Host" },
  { id: 9, name: "Manager", value: "Manager" },
  { id: 10, name: "Owner", value: "Owner" },
  { id: 11, name: "Other", value: "Other" },
  { id: 12, name: "Proprietor", value: "Proprietor" },
  { id: 13, name: "Receptionist", value: "Receptionist" },
  { id: 14, name: "Sue-Chef", value: "Sue-Chef" },
  { id: 15, name: "Waiter", value: "Waiter" },
];

export class VendorPointOfContactsEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropDownBox: true,
      selectedPositionError: false,
      editButton: false,
      actionButton: true,
      loader: false,
      selectedTab: 1,
      onPositionModel: false,
      firstName: "",
      lastName: "",
      selected_position: "",
      position: "",
      country_code: "",
      enquiry_emails: [""],
      emailError: "",
      phone_numbers: [{ country_code: "", mobile_no: "" }],
      phoneError: "",
      profile_Photo: "",
      photo_thumbnails: "",
      defaultChecked: false,
      contacts_array: [],
      editKey: "",
      errors: {},
      error: null,
      isLoading: false,
    };
  }

  componentDidMount() {
    if (this.props.auth.loader) {
      this.setState({
        loader: this.props.auth.loader,
      });
    }
    this.setState({ isLoading: true });
    axios
      .get("https://ipapi.co/json")
      .then((result) =>
        this.setState({
          country_code: result.data.country_calling_code,
          isLoading: false,
        })
      )
      .catch((error) =>
        this.setState({
          error,
          isLoading: false,
        })
      );
  }

  static getDerivedStateFromProps(nextProps, nextState) {
    if (
      !isEmpty(nextProps.onboarding.point_of_contact) &&
      !nextState.hasSetMapProps
    ) {
      const contacts_array = JSON.parse(
        JSON.stringify(nextProps.onboarding.point_of_contact)
      );
      let to_be_set = contacts_array[contacts_array.length - 1];
      let to_be_displayed = contacts_array;
      to_be_displayed.splice(contacts_array.length - 1, 1);
      if (nextProps.onboarding.point_of_contact.length > 0) {
        return {
          ...nextState,
          contacts_array: to_be_displayed,
          hasSetMapProps: true,
          ...to_be_set,
        };
      }
    }
    if (nextProps.auth.loader !== nextState.loader) {
      return {
        loader: nextProps.auth.loader,
      };
    }
    if (nextProps.errors !== nextState.errors) {
      return {
        errors: nextProps.errors,
      };
    }
    return null;
  }

  /**************************************
   * @DESC EDIT BUTTON
   **************************************/
  editClick = () => {
    this.setState({ editButton: !this.state.editButton });
  };

  /**************************************
   * @DESC Positon Role Model
   *************************************/
  onPositionModel = () => {
    this.setState({
      selectedPositionError: true,
      onPositionModel: true,
    });
  };

  onPositionCloseModel = () => {
    this.setState({
      selectedPositionError: true,
      onPositionModel: false,
    });
  };

  onPositionButtonClick = (e, type) => {
    e.preventDefault();
    this.setState({
      selected_position: type,
      onPositionModel: false,
      selectedPositionError: false,
    });
  };

  onChange = (e) => {
    this.props.clear_all_errors();
    // this.setState({
    //   [e.target.name]: e.target.value,
    //   actionButton: true,
    // });
    let data = e.target.value.split(" ");
    let newarray1 = [];
    for (let x = 0; x < data.length; x++) {
      newarray1.push(data[x].charAt(0).toUpperCase() + data[x].slice(1));
    }
    let newData = newarray1.join(" ");
    this.setState({
      [e.target.name]: newData,
      actionButton: true,
    });
  };

  onPrimaryButtonChange = (index) => (e) => {
    let { contacts_array } = this.state;
    contacts_array.forEach((contact) => (contact.defaultChecked = false));
    contacts_array[index].defaultChecked =
      !contacts_array[index].defaultChecked;
    this.setState({
      contacts_array: contacts_array,
      actionButton: true,
    });
  };

  onFocusOut = (e) => {
    const { errors } = this.state;
    if (e.target.value === "") {
      errors[e.target.name] = `*Fields can’t be blank. Please enter your ${
        e.target.name === "enquiry_emails" ? "enquiry emails" : e.target.name
      }`;
    } else {
      delete errors[e.target.name];
    }
    this.setState({
      errors: errors,
      error: Object.keys(errors).length > 0 ? true : false,
      actionButton: true,
    });
  };

  /*****************************************
   * @DESC - Add Handlers
   ******************************************/
  onAddMoreContactHandler = (e) => {
    // e.preventDefault();
    this.setState({ errors: {} });
    const {
      firstName,
      lastName,
      position,
      selected_position,
      enquiry_emails,
      phone_numbers,
      contacts_array,
    } = this.state;
    if (firstName === "") {
      const { errors } = this.state;
      errors.firstName = "First Name is required";
      this.setState({
        errors: errors,
      });
    } else if (selected_position === "") {
      const { errors } = this.state;
      errors.selected_position = "Position is required";
      this.setState({
        errors: errors,
      });
    } else if (selected_position === "Other" && position === "") {
      const { errors } = this.state;
      errors.position = "Position description is required";
      this.setState({
        errors: errors,
      });
    } else if (
      enquiry_emails[enquiry_emails.length - 1] === "" ||
      !validEmailRegex.test(enquiry_emails[enquiry_emails.length - 1])
    ) {
      const { errors } = this.state;
      errors.enquiry_emails =
        "*Fields can’t be blank. Please enter your enquiry emails";
      this.setState({
        errors: errors,
      });
    } else if (
      phone_numbers[phone_numbers.length - 1].mobile_no === "" ||
      phone_numbers[phone_numbers.length - 1].mobile_no.length < 9
    ) {
      const { errors } = this.state;
      errors.mobile_no = "Phone number is required";
      this.setState({
        errors: errors,
      });
    }
    // else if(firstName === ""){
    //   const { errors } = this.state;
    //   errors.firstName = "firstName is required";
    //    this.setState({
    //     errors: errors,
    //   });
    // }
    // else if(lastName === ""){
    //   const { errors } = this.state;
    //   errors.firstName = "lastName is required";
    // // else if (profile_Photo === "") {
    // //   alert("Profile photo is required");
    // // }
    else {
      if (contacts_array.length === 0) {
        let contactData = {
          id: 1,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          selected_position: this.state.selected_position,
          position: this.state.position,
          phone_numbers: this.state.phone_numbers,
          enquiry_emails: this.state.enquiry_emails,
          photo_thumbnails: this.state.photo_thumbnails,
          // defaultChecked: this.state.defaultChecked,
          defaultChecked: true,
          profile_Photo: this.state.profile_Photo,
        };
        contacts_array.push(contactData);
        this.setState({
          contacts_array: contacts_array,
          firstName: "",
          lastName: "",
          selected_position: "",
          position: "",
          enquiry_emails: [""],
          phone_numbers: [{ country_code: "", mobile_no: "" }],
          defaultChecked: false,
          profile_Photo: "",
          photo_thumbnails: "",
          actionButton: true,
          errors: {},
        });
      } else {
        let id = contacts_array[contacts_array.length - 1].id;
        let contactData = {
          id: id + 1,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          selected_position: this.state.selected_position,
          position: this.state.position,
          phone_numbers: this.state.phone_numbers,
          enquiry_emails: this.state.enquiry_emails,
          defaultChecked: this.state.defaultChecked,
          profile_Photo: this.state.profile_Photo,
          photo_thumbnails: this.state.photo_thumbnails,
        };
        contacts_array.push(contactData);
        this.setState({
          contacts_array: contacts_array,
          firstName: "",
          lastName: "",
          selected_position: "",
          position: "",
          enquiry_emails: [""],
          phone_numbers: [{ country_code: "", mobile_no: "" }],
          defaultChecked: false,
          profile_Photo: "",
          photo_thumbnails: "",
          actionButton: true,
          errors: {},
        });
      }
    }
  };

  /*****************************************
   * @DESC - Multiple Email Handlers
   ******************************************/
  onEmailAddHandler = (e) => {
    e.preventDefault();
    let enquiry_emails = this.state.enquiry_emails;
    if (enquiry_emails.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      enquiry_emails[enquiry_emails.length - 1] === "" ||
      !validEmailRegex.test(enquiry_emails[enquiry_emails.length - 1])
    ) {
      const { errors } = this.state;
      if (e.target.value === "") {
        errors.enquiry_emails = `*Fields can’t be blank. Please enter your enquiry emails`;
      } else {
        delete errors[e.target.name];
        this.setState({ errors: {} });
      }
      this.setState({
        errors: errors,
      });
      // const { errors, isValid } = RestaurantPointOfContact(this.state);
      // if (!isValid) {
      //   this.setState({
      //     emailError: errors,
      //   });
      // }
    } else {
      enquiry_emails.push("");
      this.setState({
        enquiry_emails: enquiry_emails,
      });
    }
  };

  onEmailChangeHandler = (index) => (e) => {
    // const { errors } = this.state;
    let enquiry_emails = this.state.enquiry_emails;
    if (enquiry_emails.includes(e.target.value)) {
      alert("Email Already Exits");
    } else {
      // delete errors[e.target.name];
      enquiry_emails[index] = e.target.value;
      this.setState({
        enquiry_emails: enquiry_emails,
        emailError: "",
        // errors: {},
        actionButton: true,
      });
    }
  };

  onEmailDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let enquiry_emails = this.state.enquiry_emails;
    if (enquiry_emails.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      enquiry_emails.splice(index, 1);
      this.setState({ enquiry_emails: enquiry_emails });
    }
  };

  /*****************************************
   * @DESC - Multiple Phone Handlers
   ******************************************/
  onPhondeAddHandler = (e) => {
    e.preventDefault();
    let phone_numbers = this.state.phone_numbers;
    if (phone_numbers.length >= 5) {
      Alert.error("<h4>Unable Add More Field</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else if (
      phone_numbers[phone_numbers.length - 1].mobile_no === "" ||
      phone_numbers[phone_numbers.length - 1].mobile_no <= 9
    ) {
      // const { errors, isValid } = RestaurantPointOfContact(this.state);
      // if (!isValid) {
      //   this.setState({
      //     phoneError: errors,
      //   });
      // }phone number is required
      const { errors } = this.state;
      if (e.target.value === "") {
        errors.mobile_no = `phone number is required`;
      } else {
        delete errors[e.target.name];
        this.setState({ errors: {} });
      }
      this.setState({
        errors: errors,
      });
    } else {
      phone_numbers.push({
        country_code: this.state.country_code,
        mobile_no: "",
      });
      this.setState({
        phone_numbers: phone_numbers,
      });
    }
  };

  onPhoneChangeHandler = (index) => (e) => {
    let phone_numbers = this.state.phone_numbers;
    if (phone_numbers.some((diner) => diner.mobile_no === e.target.value)) {
      alert("Phone Number Already Exits");
    } else {
      phone_numbers[index].country_code =
        phone_numbers[index].country_code === ""
          ? this.state.country_code
          : phone_numbers[index].country_code;
      phone_numbers[index].mobile_no = e.target.value.slice(
        0,
        e.target.maxLength
      );
      this.setState({
        phone_numbers: phone_numbers,
        phoneError: "",
        actionButton: true,
      });
    }
  };

  onCountryCodeChangeHandler = (index) => (e) => {
    let phone_numbers = this.state.phone_numbers;
    phone_numbers[index].country_code = e.target.value;
    this.setState({
      phone_numbers: phone_numbers,
      phoneError: "",
      actionButton: true,
    });
  };

  onPhoneDeleteHandler = (index) => (e) => {
    e.preventDefault();
    let phone_numbers = this.state.phone_numbers;
    if (phone_numbers.length === 1) {
      Alert.error("<h4>Cannot Delete</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    } else {
      phone_numbers.splice(index, 1);
      this.setState({ phone_numbers: phone_numbers });
    }
  };

  /**************************************
   * @DESC - ON IMAGE UPLOAD HANDLER
   * @DESC - USER DEFINED METHODS
   **************************************/

  onCompleteCrop = (url) => {
    let photo_thumbnails = "";
    let thumbData = this.state.profile_Photo;
    let url1 = url.split("/");
    url1.splice(url1.length - 1, 0, "thumbnail");
    url1 = url1.join("/");
    // thumbData = thumbData.concat(url1);
    photo_thumbnails = url1;
    this.setState({
      profile_Photo: url,
      photo_thumbnails: photo_thumbnails,
      logo_main: null,
      singleImageLoader: false,
      actionButton: true,
    });
  };

  onCancelCrop = () => {
    this.setState({ logo_main: null });
  };

  onImageLogoUploadHandler = (e) => {
    // this.setState({ singleImageLoader: true });
    // console.log(e.target.files[0]);
    if (e.target.files) {
      const vendor_id = this.props.auth.user.VendorUser._id;
      const restaurant_name = this.props.onboarding.restaurant_name
        .split(" ")
        .join("");
      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      data.append("files", e.target.files[0]);
      if (e.target.files[0].size > imageUploadSize) {
        alert("File is too Big");
      } else {
        this.setState({
          logo_main: e.target.files[0],
          combined: combined,
        });
        //   axios
        //     .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data, {
        //       headers: {
        //         "Content-Type": "multipart/form-data",
        //       },
        //     })
        //     .then((res) => {
        //       this.setState({
        //         profile_Photo: res.data[0],
        //         actionButton: true,
        //       });
        //       Alert.success(`<h4>Restaurant Logo Upload Successfully</h4>`, {
        //         position: "top-right",
        //         effect: "bouncyflip",
        //         beep: true,
        //         html: true,
        //         timeout: 3000,
        //         offset: 35,
        //       });
        //     })
        //     .catch((err) => {
        //       // this.setState({ singleImageLoader: false });
        //       Alert.error(`<h4>Error while uploading the image</h4>`, {
        //         position: "top-right",
        //         effect: "bouncyflip",
        //         beep: true,
        //         html: true,
        //         timeout: 3000,
        //         offset: 35,
        //       });
        //     });
      }
    }
    e.target.value = "";
  };

  removeFile = (e) => {
    let restaurantLogo = this.state.profile_Photo;
    restaurantLogo = "";
    this.setState({
      profile_Photo: restaurantLogo,
      photo_thumbnails: "",
      actionButton: true,
    });
  };

  /******************************
   * ONEDIT BUTTON HANDLER
   ******************************/
  onEditButtonCLickHandler = (id) => (e) => {
    this.setState({
      errors: {},
    });
    let contacts_array = this.state.contacts_array;
    let phoneObj = contacts_array.find((phone) => phone.id === id);
    let indexOf = contacts_array.indexOf(phoneObj);
    let contactData = {
      id: contacts_array.length + 1,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      selected_position: this.state.selected_position,
      position: this.state.position,
      phone_numbers: this.state.phone_numbers,
      enquiry_emails: this.state.enquiry_emails,
      defaultChecked: this.state.defaultChecked,
      profile_Photo: this.state.profile_Photo,
    };
    let to_be_set = contacts_array[indexOf];
    contacts_array.splice(indexOf, 1);
    contacts_array.push(contactData);
    this.setState({
      editKey: id,
      // firstName: contacts_array[indexOf].firstName,
      // lastName: contacts_array[indexOf].lastName,
      // selected_position: contacts_array[indexOf].selected_position,
      // position: contacts_array[indexOf].position,
      // enquiry_emails: contacts_array[indexOf].enquiry_emails,
      // phone_numbers: contacts_array[indexOf].phone_numbers,
      contacts_array: contacts_array,
      ...to_be_set,
    });
  };
  /******************************
   * ONEDIT SAVE HANDLER
   ******************************/
  onEditSaveHandler = (e) => {
    e.preventDefault();
    let contacts_array = this.state.contacts_array;
    let contactData = {
      id: contacts_array.length + 1,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      selected_position: this.state.selected_position,
      position: this.state.position,
      phone_numbers: this.state.phone_numbers,
      enquiry_emails: this.state.enquiry_emails,
      defaultChecked: this.state.defaultChecked,
      profile_Photo: this.state.profile_Photo,
      photo_thumbnails: this.state.photo_thumbnails,
    };

    let to_be_set = contacts_array[contacts_array.length - 1];
    let to_be_displayed = contacts_array;
    to_be_displayed.splice(contacts_array.length - 1, 1);
    to_be_displayed.push(contactData);

    this.setState({
      contacts_array: contacts_array,
      editKey: "",
      profile_Photo: "",
      photo_thumbnails: "",
      ...to_be_set,
    });
    // contacts_array.push(contactData);
    // this.setState({
    //   contacts_array: contacts_array,
    //   editKey: "",
    //   firstName: "",
    //   lastName: "",
    //   selected_position: "",
    //   position: "",
    //   enquiry_emails: [""],
    //   phone_numbers: [{ country_code: "", mobile_no: "" }],
    //   defaultChecked: false,
    //   profile_Photo: "",
    //   photo_thumbnails: "",
    // });
  };
  // onEditSaveHandlerNew = (e) => {
  //   e.preventDefault();
  //   this.setState({
  //     editKey: "",
  //   });
  // };

  /******************************
   * ONCLICK DELETE HANDLER
   ******************************/
  onClickContactDelete = (id) => (e) => {
    e.preventDefault();
    let contacts_array = this.state.contacts_array;
    let emailObj = contacts_array.find((email) => email.id === id);
    if (emailObj === 0 || emailObj) {
      contacts_array.splice(contacts_array.indexOf(emailObj), 1);
      this.setState({ contacts_array: contacts_array, actionButton: true });
    }
  };
  onBackButton = (history) => (e) => {
    e.preventDefault();
    const sendData = {
      data: true,
      actionButton: 1,
    };
    history.push({
      pathname: "/profile",
      state: { formData: sendData },
    });
  };

  withOutApiCall = (e) => {
    let actionCall = false;
    let contactData = this.state.contacts_array;
    contactData.filter((elements) => {
      if (elements.defaultChecked === true) {
        actionCall = true;
      }
    });
    if (actionCall) {
      this.props.history.push({
        pathname: "/profile",
      });
    } else {
      Alert.error("<h4>Please select atlest one set as default contact</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    }
  };

  /************************************
   * @DESC Drop Down Box Handler
   ***********************************/
  dropDownBoxClick = (e) => {
    e.preventDefault();
    this.setState({
      dropDownBox: !this.state.dropDownBox,
      actionButton: true,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    if (this.state.firstName && this.state.lastName) {
      this.onAddMoreContactHandler();
    }
    let actionCall = false;
    let contactData = this.state.contacts_array;
    contactData.filter((elements) => {
      if (elements.defaultChecked === true) {
        actionCall = true;
      }
    });
    if (actionCall) {
      if (
        this.props.onboarding &&
        this.props.onboarding.point_of_contact.length > 0
      ) {
        let formData = {
          vendor_id: this.props.onboarding.vendor_id,
          id: this.props.onboarding._id,
          point_of_contact: this.state.contacts_array,
        };
        this.props.create_and_update_restaurant(formData);
        this.setState({
          actionButton: false,
        });
        this.props.history.push({
          pathname: "/profile",
        });
      } else {
        let formData = {
          vendor_id: this.props.onboarding.vendor_id,
          id: this.props.onboarding._id,
          point_of_contact: this.state.contacts_array,
          page_completed_till: 3,
        };
        this.props.create_and_update_restaurant(formData);
        this.setState({
          actionButton: false,
        });
        this.props.history.push({
          pathname: "/profile",
        });
      }
    } else {
      Alert.error("<h4>Please select atlest one set as default contact</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 2000,
        offset: 35,
      });
    }
  };

  render() {
    if (this.state.loader) {
      return (
        <React.Fragment>
          <AmealioLoader />
        </React.Fragment>
      );
    }
    const {
      dropDownBox,
      editButton,
      actionButton,
      errors,
      firstName,
      lastName,
      selected_position,
      position,
      contacts_array,
      enquiry_emails,
      phone_numbers,
      profile_Photo,
      error,
    } = this.state;

    let revenueDataSort = revenueData.sort(function (a, b) {
      return a.name
        .toString()
        .toLowerCase()
        .localeCompare(b.name.toString().toLowerCase());
    });

    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>

            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/profile"
                displayText="Back"
              />
              <div id="onboarding-scrollbar" className="col-12 col-md-6">
                <div>
                  <div>
                    <TopTextReusableComponent
                      headingText="Point of Contact"
                      headingParagraph="Enter the information for the Location Manager and Other Point of Contacts"
                      displayEdit={editButton}
                      onClickEdit={this.editClick}
                    />
                  </div>
                  <Form noValidate onSubmit={this.handleSubmit}>
                    <div className="point_of_contact_onboarding_main">
                      <div className="row">
                        <div className="col-6">
                          <NewInputText
                            extraClass="mt-4 mb-1"
                            name="firstName"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.firstName}
                            maxLength={35}
                            disabled={
                              this.state.editButton === false ? true : false
                            }
                            // errorText={errors.firstName}
                            // errorTrue={errors.firstName === "" ? true : false}
                            labelText="First Name*"
                            // controlClass={
                            //   errors.firstName ===
                            //     "*Fields can’t be blank. Please enter your firstName" &&
                            //   errors.firstName === "FirstName Is Required"
                            //     ? "outlined-error-helper-text"
                            //     : "outlined-helperText "
                            // }
                          />
                          <div
                            className={`f10-500 mt-1 ${
                              errors.firstName !== "" ? "mb-3" : "mb-0"
                            }`}
                            style={{ color: "#EE3A23" }}
                          >
                            {errors.firstName}
                          </div>
                        </div>
                        <div className="col-6">
                          <NewInputText
                            extraClass="mt-4 mb-1"
                            name="lastName"
                            inputType="text"
                            onChange={this.onChange}
                            onFocusOut={this.onFocusOut}
                            onKeyDown={InputCharacterCheck}
                            value={this.state.lastName}
                            maxLength={35}
                            disabled={
                              this.state.editButton === false ? true : false
                            }
                            // errorText={errors.lastName}
                            // errorTrue={errors.lastName === "" ? true : false}
                            labelText="Last Name"
                            // controlClass={
                            //   errors.lastName ===
                            //   "*Fields can’t be blank. Please enter your lastName"
                            //     ? "outlined-error-helper-text"
                            //     : "outlined-helperText "
                            // }
                          />
                          <div
                            className={`f10-500 mt-1 ${
                              errors.lastName !== "" ? "mb-3" : "mb-0"
                            }`}
                            style={{ color: "#EE3A23" }}
                          >
                            {errors.lastName}
                          </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                          <div className="row">
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6 ">
                              <div className="position-relative ">
                                <SelectBoxMUiInputComponent
                                  extraClass={false}
                                  displayNone={true}
                                  selectLabel="Position*"
                                  name="selected_position"
                                  value={this.state.selected_position}
                                  onChange={this.onChange}
                                  getData={revenueDataSort}
                                  disabled={
                                    this.state.editButton === false
                                      ? true
                                      : false
                                  }
                                  // errorText={errors.selected_position}
                                  // errorTrue={
                                  //   errors.selected_position === "" ? true : false
                                  // }
                                  helperText="Please select your currency"
                                />
                                <div
                                  className={`f10-500 mt-1 ${
                                    errors.selected_position ===
                                    "Position is required"
                                      ? "mb-3"
                                      : "mb-0"
                                  }`}
                                  style={{ color: "#EE3A23" }}
                                >
                                  {errors.selected_position}
                                </div>
                                <div className="f9-400 opacity5">
                                  Enter the Position for Point of Contact - this
                                  is required info
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                              {selected_position === "Other" ? (
                                <>
                                  <NewInputText
                                    extraClass="mb-0 position-discription-mobile"
                                    name="position"
                                    inputType="text"
                                    onChange={this.onChange}
                                    onFocusOut={this.onFocusOut}
                                    onKeyDown={InputCharacterCheck}
                                    value={this.state.position}
                                    disabled={
                                      this.state.editButton === false
                                        ? true
                                        : false
                                    }
                                    // errorText={errors.position}
                                    // errorTrue={
                                    //   errors.position ===
                                    //     "*Fields can’t be blank. Please enter your position" ||
                                    //   errors.position ===
                                    //     "Position description is required"
                                    //     ? true
                                    //     : false
                                    // }
                                    labelText="Description of Position*"
                                    // controlClass={
                                    //   errors.position ===
                                    //     "*Fields can’t be blank. Please enter your position" ||
                                    //   errors.position ===
                                    //     "Position description is required"
                                    //     ? "outlined-error-helper-text"
                                    //     : "outlined-helperText "
                                    // }
                                  />
                                  <div
                                    className={`f10-500 mt-1 ${
                                      errors.position !== "" ? "mb-3" : "mb-0"
                                    }`}
                                    style={{ color: "#EE3A23" }}
                                  >
                                    {errors.position}
                                  </div>
                                </>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      </div>
                      {this.state.enquiry_emails.map((email, index) => (
                        <div
                          className="row align-items-center mb-4 mt-4"
                          key={index}
                        >
                          <div className="col-9">
                            <NewInputText
                              extraClass="mt-0 mb-0"
                              name="enquiry_emails"
                              inputType="email"
                              onFocusOut={this.onFocusOut}
                              onChange={this.onEmailChangeHandler(index)}
                              value={email}
                              disabled={
                                this.state.editButton === false ? true : false
                              }
                              errorText={errors.enquiry_emails}
                              errorTrue={
                                errors.enquiry_emails === "" ||
                                (!validEmailRegex.test(email) &&
                                  !isEmpty(email)) ||
                                (email === "" &&
                                  errors.enquiry_emails ===
                                    "*Fields can’t be blank. Please enter your enquiry emails") ||
                                (email === "" &&
                                  errors.enquiry_emails ===
                                    "*Fields can’t be blank. Please enter your enquiry emails")
                                  ? true
                                  : false
                              }
                              labelText="Enquiry Email*"
                              controlClass={
                                !validEmailRegex.test(email) &&
                                errors?.enquiry_emails
                                  ? "outlined-error-helper-text"
                                  : "outlined-helperText"
                              }
                            />
                          </div>
                          <div className="col-3 restaurant_details_onboarding_minus_button">
                            {this.state.enquiry_emails.length > 1 ? (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Delete"
                                  onClick={this.onEmailDeleteHandler(index)}
                                  fontIcon="fa fa-trash-o"
                                  colorCss="delete"
                                  disabled={
                                    this.state.editButton === false
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            ) : (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Add Another"
                                  onClick={this.onEmailAddHandler}
                                  fontIcon="fa fa-plus"
                                  colorCss="blue"
                                  disabled={
                                    this.state.editButton === false
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                      {this.state.enquiry_emails.length > 1 ? (
                        <div className="col-12 p-0 mb-4 restaurant_details_onboarding_minus_button add_email_button">
                          <div>
                            <AddButtonIconComponent
                              buttonText="Add Another Email"
                              onClick={this.onEmailAddHandler}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                              disabled={
                                this.state.editButton === false ? true : false
                              }
                            />
                          </div>
                        </div>
                      ) : null}

                      {this.state.phone_numbers.map((phone, index) => (
                        <div
                          className="row  align-items-center mb-4"
                          key={index}
                        >
                          <div className="col-4 col-xl-3">
                            <Form.Group
                              className="reusableInputComponent-main mb-0"
                              controlId={"country_code"}
                            >
                              <div className="input-phone-country-code-reusable w-100">
                                <select
                                  className="w-100"
                                  name="country_code"
                                  value={phone.country_code}
                                  onChange={this.onCountryCodeChangeHandler(
                                    index
                                  )}
                                  disabled={
                                    this.state.editButton === false
                                      ? true
                                      : false
                                  }
                                >
                                  <option
                                    value={
                                      phone.country_code === ""
                                        ? this.state.country_code
                                        : phone.country_code
                                    }
                                  >
                                    {phone.country_code === ""
                                      ? this.state.country_code
                                      : phone.country_code}
                                  </option>
                                  {getCountries().map((country) => (
                                    <option
                                      key={country}
                                      value={
                                        "+" + getCountryCallingCode(country)
                                      }
                                      onClick={this.onChangeCountry}
                                    >
                                      {en[country]} (+
                                      {getCountryCallingCode(country)})
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </Form.Group>
                          </div>
                          <div className="col-5 col-xl-6 pl-0">
                            <NewInputText
                              extraClass="mb-0"
                              name="mobile_no"
                              inputType="number"
                              onFocusOut={this.onFocusOut}
                              onChange={this.onPhoneChangeHandler(index)}
                              value={phone.mobile_no}
                              maxLength="10"
                              onKeyDown={InputNumberFunc}
                              disabled={
                                this.state.editButton === false ? true : false
                              }
                              errorText={
                                (phone.mobile_no.length > 0 &&
                                  phone.mobile_no.length <= 9) ||
                                errors?.mobile_no
                                  ? "Enter your valid mobile number"
                                  : null
                              }
                              errorTrue={
                                (phone.mobile_no.length > 0 &&
                                  phone.mobile_no.length <= 9) ||
                                errors?.mobile_no
                                  ? true
                                  : false
                              }
                              labelText="Phone Number*"
                              controlClass={
                                (phone.mobile_no.length > 0 &&
                                  phone.mobile_no.length <= 9) ||
                                errors?.mobile_no
                                  ? "outlined-error-helper-text"
                                  : "outlined-helperText"
                              }
                            />
                          </div>

                          <div className="col-3 restaurant_details_onboarding_minus_button">
                            {this.state.phone_numbers.length > 1 ? (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Delete"
                                  onClick={this.onPhoneDeleteHandler(index)}
                                  fontIcon="fa fa-trash-o"
                                  colorCss="delete"
                                  disabled={
                                    this.state.editButton === false
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            ) : (
                              <div>
                                <AddButtonIconComponent
                                  buttonText="Add Another"
                                  onClick={this.onPhondeAddHandler}
                                  fontIcon="fa fa-plus"
                                  colorCss="blue"
                                  disabled={
                                    this.state.editButton === false
                                      ? true
                                      : false
                                  }
                                />
                              </div>
                            )}
                          </div>
                        </div>
                      ))}
                      {this.state.phone_numbers.length > 1 ? (
                        <div className="col-12 p-0 mt-3 restaurant_details_onboarding_minus_button add_email_button">
                          <div>
                            <AddButtonIconComponent
                              buttonText="Add Another Phone Number"
                              onClick={this.onPhondeAddHandler}
                              fontIcon="fa fa-plus"
                              colorCss="blue"
                              disabled={
                                this.state.editButton === false ? true : false
                              }
                            />
                          </div>
                        </div>
                      ) : null}
                      <SimpleReactLightbox>
                        <SingleImageReusableComponent
                          title="Add Profile Image"
                          onChange={this.onImageLogoUploadHandler}
                          combined={this.state.combined && this.state.combined}
                          onCompleteCrop={this.onCompleteCrop}
                          onCancelCrop={this.onCancelCrop}
                          file={
                            (this.state.logo_main && this.state.logo_main) ||
                            this.state?.photo_thumbnails ||
                            this.state?.profile_Photo
                          }
                          resetFile={this.removeFile}
                          name="profile_Photo"
                          error={errors?.profile_Photo}
                          thumbnail={true}
                          checkCondition={
                            this.state.editButton === false ? false : true
                          }
                          accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                        />
                        <FormHelperText id="outlined-error-helper-text">
                          Only .jpg and .png files. 500kb max file size
                        </FormHelperText>
                      </SimpleReactLightbox>
                      <p></p>
                      <div className="row">
                        <div className="col-5">
                          {this.state.editKey ? null : (
                            // <ReusableOnboardingMapButton
                            //   // classsection="onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_point"
                            //   classsection="min-vw-25 border border-danger f18_400_HelveticaNeue"
                            //   title="Save"
                            //   onClick={this.onAddMoreContactHandler}
                            // />
                            <button
                              className="w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_point f14_400_HelveticaNeue justify-content-center"
                              style={{ color: "#EE3A23" }}
                              title="Save"
                              type="button"
                              onClick={this.onAddMoreContactHandler}
                              disabled={
                                this.state.editButton === false ? true : false
                              }
                            >
                              Save
                            </button>
                          )}
                        </div>
                        <div className="col-5">
                          {this.state.editKey ? null : (
                            <button
                              className="w-100 onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_point f14_400_HelveticaNeue justify-content-center"
                              style={{ color: "#EE3A23" }}
                              title="Save And Add Another"
                              type="button"
                              onClick={this.onAddMoreContactHandler}
                              disabled={
                                this.state.editButton === false ? true : false
                              }
                            >
                              Save And Add Another
                            </button>
                          )}
                        </div>
                      </div>
                      <hr />
                      <div className="row ">
                        {this.state.editKey === "" ? (
                          <div className="onboarding_process_screen-left-mapinside p-0">
                            <div className="col-12 map-button-box-main">
                              <DropDownBoxCrret
                                state={dropDownBox}
                                showText="Hide added contacts"
                                hideText="Show added contacts"
                                onClick={this.dropDownBoxClick}
                              />
                              {dropDownBox ? (
                                <div className="onboarding-point-of-contact-table">
                                  <div className="row">
                                    <div className="col-4">
                                      <h4 className="big_heading_text">
                                        Added Contacts
                                      </h4>
                                    </div>
                                    <div className="col-8">
                                      <div className="row">
                                        <div className="col-4">
                                          <h4 className="big_heading_text">
                                            Profile Photo
                                          </h4>
                                        </div>
                                        <div className="col-4">
                                          <h4 className="big_heading_text">
                                            Set as default contact
                                          </h4>
                                        </div>
                                        <div className="col-4">
                                          <h4 className="big_heading_text">
                                            Action
                                          </h4>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  {this.state.contacts_array.map(
                                    (contact, index) => (
                                      <div
                                        className="row point_of_contact_table-div"
                                        key={index}
                                      >
                                        <div className="col-4 pr-0">
                                          {this.state.editKey === "" ? (
                                            <div className="">
                                              <div className="f14-700">
                                                {contact.firstName +
                                                  " " +
                                                  contact.lastName}{" "}
                                              </div>
                                              <span className="f9-500 opacity5">
                                                {`(
                                      ${contact.selected_position}
                                      ) `}
                                              </span>
                                              {contact.position && (
                                                <span className="f9-500 opacity5">
                                                  {`(
                                      ${contact.position}
                                      ) `}
                                                </span>
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          {this.state.editKey === "" ? (
                                            <div className="mt-2">
                                              {contact.phone_numbers.map(
                                                (phone, index) => (
                                                  <p
                                                    className="f12-400 opacity5"
                                                    key={index}
                                                  >
                                                    {phone.country_code +
                                                      "-" +
                                                      phone.mobile_no}
                                                  </p>
                                                )
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                          {this.state.editKey === "" ? (
                                            <div className="mt-2">
                                              {contact.enquiry_emails.map(
                                                (email, index) => (
                                                  <p
                                                    className="f12-400 opacity5"
                                                    key={index}
                                                  >
                                                    {email}
                                                  </p>
                                                )
                                              )}
                                            </div>
                                          ) : (
                                            ""
                                          )}
                                        </div>
                                        <div className="col-8">
                                          <div className="row">
                                            <div className="col-4">
                                              {this.state.editKey === "" ? (
                                                <div className="lightBoxWraper enIMG33 rounded-circle">
                                                  {contact.profile_Photo ===
                                                  "" ? (
                                                    ""
                                                  ) : (
                                                    <SimpleReactLightbox>
                                                      <SRLWrapper
                                                        options={options}
                                                      >
                                                        <img
                                                          src={
                                                            contact.profile_Photo
                                                          }
                                                          className="img-fluid"
                                                          alt="Profile Photo"
                                                          title="Profile Photo"
                                                        />
                                                      </SRLWrapper>
                                                    </SimpleReactLightbox>
                                                  )}
                                                </div>
                                              ) : (
                                                ""
                                              )}
                                            </div>
                                            <div className="col-4">
                                              {this.state.editKey === "" ? (
                                                <label className="enRadioWithText small">
                                                  <input
                                                    type="radio"
                                                    name="defaultChecked"
                                                    checked={
                                                      this.state.contacts_array[
                                                        index
                                                      ].defaultChecked === true
                                                        ? true
                                                        : false
                                                    }
                                                    disabled={
                                                      this.state.editButton ===
                                                      false
                                                        ? true
                                                        : false
                                                    }
                                                    onChange={this.onPrimaryButtonChange(
                                                      index
                                                    )}
                                                  />
                                                  <span className="checkmark"></span>
                                                </label>
                                              ) : null}
                                            </div>
                                            <div className="col-4 d-flex">
                                              {this.state.editKey === "" ? (
                                                <IconButton
                                                  className="mr-2 p-0"
                                                  onClick={this.onEditButtonCLickHandler(
                                                    contact.id
                                                  )}
                                                  disabled={
                                                    this.state.editButton ===
                                                    false
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  <Image
                                                    src={require("../../../../assets/images/UserManagement/editBlue.svg")}
                                                    alt="Edit"
                                                    title="Edit"
                                                    className="w-20px"
                                                  />
                                                </IconButton>
                                              ) : null}

                                              {this.state.editKey === "" ? (
                                                <IconButton
                                                  className="p-0"
                                                  onClick={this.onClickContactDelete(
                                                    contact.id
                                                  )}
                                                  disabled={
                                                    this.state.editButton ===
                                                    false
                                                      ? true
                                                      : false
                                                  }
                                                >
                                                  <Image
                                                    src={require("../../../../assets/images/UserManagement/delete-gray.svg")}
                                                    alt="Delete"
                                                    title="Delete"
                                                    className="w-20px"
                                                  />
                                                </IconButton>
                                              ) : null}
                                            </div>
                                          </div>
                                        </div>
                                        {this.state.editKey === "" ? (
                                          <div className="col-12">
                                            <hr />
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div>
                                    )
                                  )}
                                </div>
                              ) : null}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                      <div className="onboarding-map-setup-screen-autodetect-button my-4">
                        {this.state.editKey ? (
                          <ReusableOnboardingButton
                            buttonTitle="Back Button"
                            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                            buttonText="Back"
                            buttonType="button"
                            // link="/restaurantsettings"
                            onClick={this.onEditSaveHandler}
                          />
                        ) : (
                          <ReusableOnboardingButton
                            buttonTitle="Back Button"
                            buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                            buttonText="Back"
                            buttonType="button"
                            onClick={this.onBackButton(this.props.history)}
                          />
                        )}
                        {contacts_array.length <= 0 ? (
                          this.state.editButton ? (
                            <div>
                              <ReusableOnboardingButton
                                buttonTitle="Next Button"
                                buttonClass={
                                  firstName === "" ||
                                  lastName === "" ||
                                  // selected_position === "" ||
                                  // profile_Photo === "" ||
                                  // (selected_position === "Other" &&
                                  //   position === "") ||
                                  enquiry_emails[enquiry_emails.length - 1] ===
                                    "" ||
                                  phone_numbers[phone_numbers.length - 1]
                                    .mobile_no === "" ||
                                  phone_numbers[phone_numbers.length - 1]
                                    .mobile_no.length <= 9 ||
                                  !validEmailRegex.test(
                                    enquiry_emails[enquiry_emails.length - 1]
                                  )
                                    ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                                }
                                disabled={
                                  firstName === "" ||
                                  lastName === "" ||
                                  // selected_position === "" ||
                                  // profile_Photo === "" ||
                                  // (selected_position === "Other" &&
                                  //   position === "") ||
                                  enquiry_emails[enquiry_emails.length - 1] ===
                                    "" ||
                                  phone_numbers[phone_numbers.length - 1]
                                    .mobile_no === "" ||
                                  phone_numbers[phone_numbers.length - 1]
                                    .mobile_no.length <= 9 ||
                                  !validEmailRegex.test(
                                    enquiry_emails[enquiry_emails.length - 1]
                                  ) ||
                                  errors
                                    ? true
                                    : false
                                }
                                buttonText="Next"
                                onClick={
                                  actionButton === false
                                    ? this.withOutApiCall
                                    : null
                                }
                                buttonType={
                                  actionButton === false ? "button" : "submit"
                                }
                              />
                            </div>
                          ) : (
                            <></>
                          )
                        ) : this.state.editButton ? (
                          <div>
                            {this.state.editKey ? (
                              <ReusableOnboardingButton
                                buttonTitle="Save Button"
                                buttonClass={
                                  firstName === "" ||
                                  lastName === "" ||
                                  // selected_position === "" ||
                                  // profile_Photo === "" ||
                                  // (selected_position === "Other" &&
                                  //   position === "") ||
                                  enquiry_emails[enquiry_emails.length - 1] ===
                                    "" ||
                                  phone_numbers[phone_numbers.length - 1]
                                    .mobile_no === "" ||
                                  phone_numbers[phone_numbers.length - 1]
                                    .mobile_no.length <= 9 ||
                                  !validEmailRegex.test(
                                    enquiry_emails[enquiry_emails.length - 1]
                                  ) ||
                                  error
                                    ? "onboarding_button_link_reusable onboarding_button_link_reusable_gray ml-3"
                                    : "onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                                }
                                disabled={
                                  firstName === "" ||
                                  lastName === "" ||
                                  // selected_position === "" ||
                                  // profile_Photo === "" ||
                                  // (selected_position === "Other" &&
                                  //   position === "") ||
                                  enquiry_emails[enquiry_emails.length - 1] ===
                                    "" ||
                                  phone_numbers[phone_numbers.length - 1]
                                    .mobile_no === "" ||
                                  phone_numbers[phone_numbers.length - 1]
                                    .mobile_no.length <= 9 ||
                                  !validEmailRegex.test(
                                    enquiry_emails[enquiry_emails.length - 1]
                                  ) ||
                                  error
                                    ? true
                                    : false
                                }
                                buttonText="Save"
                                buttonType="button"
                                onClick={this.onEditSaveHandler}
                              />
                            ) : (
                              <>
                                <ReusableOnboardingButton
                                  buttonTitle="Next Button"
                                  buttonClass={`onboarding_button_link_reusable ${
                                    point_of_contact_error_check(
                                      this.state,
                                      error
                                    )
                                      ? "onboarding_button_link_reusable_gray ml-3"
                                      : "onboarding_button_link_reusable_red ml-3"
                                  }`}
                                  disabled={
                                    point_of_contact_error_check(
                                      this.state,
                                      error
                                    )
                                      ? true
                                      : false
                                  }
                                  buttonText="Next"
                                  onClick={
                                    actionButton === false
                                      ? this.withOutApiCall
                                      : null
                                  }
                                  buttonType={
                                    actionButton === false ? "button" : "submit"
                                  }
                                />
                              </>
                            )}
                          </div>
                        ) : (
                          <></>
                        )}
                      </div>
                    </div>
                  </Form>
                </div>
              </div>
            </div>

            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

VendorPointOfContactsEdit.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  storage: state.storage,
  onboarding: state.onboarding.restaurantDetails,
  vendorAccess: state.vendorAccess,
});

export default connect(mapStateToProps, {
  clear_all_errors,
  create_and_update_restaurant,
})(withRouter(VendorPointOfContactsEdit));
